<template>
    <sections>
        <section-contact heading="Contact" content="<article-contact />"></section-contact>
    </sections>
</template>

<script setup>
const $config = useRuntimeConfig();
useSeo().buildHead({
    title: 'Contact | ' + $config.public.siteName,
    description: 'Please feel free get in touch.',
    index: true,
});
</script>
